import * as Types from '@/__gen/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SendMessageMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  content: Types.Scalars['String']['input'];
  createChatForFormLlmInterface: Types.Scalars['ID']['input'];
  chat: Types.Scalars['ID']['input'];
  recordId: Types.Scalars['ID']['input'];
}>;


export type SendMessageMutation = { __typename: 'PharosMutations', llmChatMessage_Update: { __typename: 'llm_chat_messagePayload', object: { __typename: 'LLmChatMessageType', id: string, chat: { __typename: 'LlmChatType', id: string } } | null, errors: Array<{ __typename: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type PollLlmChatQueryVariables = Types.Exact<{
  chatId: Types.Scalars['ID']['input'];
}>;


export type PollLlmChatQuery = { __typename: 'PharosQuery', llmChat: { __typename: 'LlmChatType', id: string, created: string, messages: Array<{ __typename: 'LLmChatMessageType', id: string, content: string, created: string, sender: Types.LlmChatMessageSenderType, responseReceivedAt: string | null }> } | null };


export const SendMessageDocument = gql`
    mutation sendMessage($id: ID!, $content: String!, $createChatForFormLlmInterface: ID!, $chat: ID!, $recordId: ID!) {
  llmChatMessage_Update(
    input: {id: $id, content: $content, chat: $chat, record: $recordId, createChatForFormLlmInterface: $createChatForFormLlmInterface}
  ) {
    object {
      id
      chat {
        id
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      content: // value for 'content'
 *      createChatForFormLlmInterface: // value for 'createChatForFormLlmInterface'
 *      chat: // value for 'chat'
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const PollLlmChatDocument = gql`
    query PollLlmChat($chatId: ID!) {
  llmChat(id: $chatId) {
    id
    created
    messages(orderBy: [{field: created, direction: ASC}]) {
      id
      content
      created
      sender
      responseReceivedAt
    }
  }
}
    `;

/**
 * __usePollLlmChatQuery__
 *
 * To run a query within a React component, call `usePollLlmChatQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollLlmChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollLlmChatQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function usePollLlmChatQuery(baseOptions: Apollo.QueryHookOptions<PollLlmChatQuery, PollLlmChatQueryVariables> & ({ variables: PollLlmChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PollLlmChatQuery, PollLlmChatQueryVariables>(PollLlmChatDocument, options);
      }
export function usePollLlmChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PollLlmChatQuery, PollLlmChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PollLlmChatQuery, PollLlmChatQueryVariables>(PollLlmChatDocument, options);
        }
export function usePollLlmChatSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PollLlmChatQuery, PollLlmChatQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PollLlmChatQuery, PollLlmChatQueryVariables>(PollLlmChatDocument, options);
        }
export type PollLlmChatQueryHookResult = ReturnType<typeof usePollLlmChatQuery>;
export type PollLlmChatLazyQueryHookResult = ReturnType<typeof usePollLlmChatLazyQuery>;
export type PollLlmChatSuspenseQueryHookResult = ReturnType<typeof usePollLlmChatSuspenseQuery>;
export type PollLlmChatQueryResult = Apollo.QueryResult<PollLlmChatQuery, PollLlmChatQueryVariables>;